<template>
  <p v-html="visionx">{{$t(`${visionx}`)}}</p>
</template>

<script>
export default {
  props: {
    visionx: { type: String, required: true },
  },
};
</script>

<style scoped>

</style>